import { Component } from '@angular/core';
// import firebase from 'firebase/compat/app';
// import 'firebase/compat/database';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    title = 'events-attendee-facing';
    // constructor() {
    //     firebase.database.enableLogging(true);
    // }
}
